import { XMarkIcon } from "@heroicons/react/24/solid";
import { Tooltip } from "@material-tailwind/react";
import { useState } from "react";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { messages } from "../../utils/constantMessages";
import { APP_NAME } from "../../utils/appConstant";

interface ContextDialogType {
  isContextBoxVisible: boolean;
  setIsContextBoxVisible: (flag: boolean) => void;
  isContextEditable: boolean;
  saveContextHandler: (context: string) => void;
  contextValue: string;
  setContextValue: (context: string) => void;
  defaultRole: boolean;
}

function ContextDialog({
  isContextBoxVisible,
  setIsContextBoxVisible,
  isContextEditable,
  saveContextHandler,
  contextValue,
  setContextValue,
  defaultRole,
}: ContextDialogType) {
  const [context, setContext] = useState(
    defaultRole === true ? "" : contextValue
  );
  const saveContext = () => {
    context === ""
      ? setContextValue(messages.DEFAULT_ROLE)
      : setContextValue(context);

    saveContextHandler(context);
    // setIsContextBoxVisible(false)
  };
  return (
    isContextBoxVisible && (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 backdrop- z-50  h-full ">
        <dialog
          open
          className="w-4/12  shadow-lg   border rounded-xl min-w-60 card_text_color card_bg_color"
        >
          <div className="">
            <div className="flex sticky top-0 p-3">
              <div className="left">
                <h2 className="text-xl ">Personalize {APP_NAME}</h2>
                <p>Help us tailor your experience</p>
              </div>
              <button
                onClick={() => setIsContextBoxVisible(false)}
                aria-label="Close"
                className="absolute top-2 right-2 z-10 rounded-full p-2 "
              >
                <XMarkIcon className="w-6 h-6  hover:text-gray-400" />
              </button>
            </div>
            <div className=" border-b "></div>
            <div className="space-y-4 p-3 overflow-auto">
              <div className="">
                <p>
                  Please share your role. &nbsp;
                  <Tooltip
                    content={
                      <div className="sm:w-80 sm:h-30 w-44 h-30 overflow-auto card_bg_color border rounded-md py-2">
                        {/* <div className="list-decimal">
                          <ul className="mx-2 text-xs">
                            <li className="ml-2">
                              <span className="font-bold">For example:</span>
                              <ul className="mx-4 text-sm list-disc">
                                <li className="ml-2">
                                  <div>
                                    I am a Program Manager overseeing 5 agile
                                    teams across multiple regions
                                  </div>
                                </li>
                                <li className="ml-2">
                                  <div>
                                    I lead product delivery across portfolios
                                    and need better ways to track business value
                                  </div>
                                </li>
                                <li className="ml-2">
                                  <div>
                                    I am an executive sponsor seeking strategic
                                    metrics to monitor initiative progress
                                  </div>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div> */}
                        <div className="mx-2 text-xs">
                          <span className="font-bold"> Examples:</span>
                          <p className="mx-2">
                            {" "}
                            Program Manager, Project Manager, Architect,
                            Engineer, Engineering Manager, Product Manager,
                            Scrum Master, Product Owner, Delivery Head, BU Head,
                            CXO, or any other role that is apt for you.
                          </p>
                        </div>
                      </div>
                    }
                    className="z-[60]"
                    placement="right"
                  >
                    <div className="absolute inline">
                      <IoMdInformationCircleOutline
                        size={22}
                        className="h-6 w-5 text-blue-gray-500"
                      />
                    </div>
                  </Tooltip>
                </p>
              </div>
              <div>
                <textarea
                  className="outline-none h-20 sm:h-28 w-full border bg-slate-900 text-white rounded-lg  p-2 "
                  placeholder={`Examples: Program Manager, Project Manager, Architect, Engineer, Engineering Manager, Product Manager, Scrum Master, Product Owner, Delivery Head, BU Head, CXO, or any other role that is apt for you`}
                  readOnly={!isContextEditable}
                  maxLength={50}
                  onChange={(e) => {
                    setContext(e.target.value);
                  }}
                  value={context}
                ></textarea>
                <div
                  className={`text-right text-sm  
                    //     {
                    //   contextValue.length > 200
                    //     ? "text-red-400"
                    //     : "text-green-400"
                    // }
                    `}
                >
                  {context.length}/50 characters
                </div>
              </div>
            </div>
          </div>
          {isContextEditable && (
            <div className="flex justify-center pt-3 pb-3">
              <button
                className="bg-slate-700 text-white rounded-md px-2 heading_text_color py-1"
                onClick={() => saveContext()}
                disabled={!isContextEditable}
              >
                Save Role
              </button>
            </div>
          )}
        </dialog>
      </div>
    )
  );
}

export default ContextDialog;
